import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { throwError } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as JourneyPlannerActions from './journey-planner.actions';
import { JourneyPlannerService } from '../journey-planner.service';
import { FavoriteStop } from '../journey-planner.model';

@Injectable()
export class JourneyPlannerEffects {
    constructor(
        private actions$: Actions,
        private journeyPlannerService: JourneyPlannerService
    ) {}
    getFavoriteStops$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(JourneyPlannerActions.getFavoriteStops),
            mergeMap(() =>
                this.journeyPlannerService.getFavoriteStops().pipe(
                    map((favoriteStops: FavoriteStop[]) =>
                        JourneyPlannerActions.getFavoriteStopsSuccess({ favoriteStops })
                    ),
                    catchError((err) => {
                        return throwError(err);
                    })
                )
            )
        );
    });
    addFavoriteStop$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(JourneyPlannerActions.addFavoriteStop),
            mergeMap((payload) =>
                this.journeyPlannerService.addFavoriteStop(payload.favoriteStop).pipe(
                    map((favoriteStop: FavoriteStop) => JourneyPlannerActions.addFavoriteStopSuccess({ favoriteStop })),
                    catchError((err) => {
                        return throwError(err);
                    })
                )
            )
        );
    });
    deleteFavoriteStops$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(JourneyPlannerActions.deleteFavoriteStops),
            mergeMap(({ favoriteStops }) =>
                this.journeyPlannerService.deleteFavoriteStops(favoriteStops).pipe(
                    map((favoriteStops: FavoriteStop[]) =>
                        JourneyPlannerActions.deleteFavoriteStopsSuccess({ favoriteStops: favoriteStops })
                    ),
                    catchError((err) => {
                        return throwError(err);
                    })
                )
            )
        );
    });
    deleteFavoriteStop$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(JourneyPlannerActions.deleteFavoriteStop),
            mergeMap(({ favoriteStop }) =>
                this.journeyPlannerService.deleteFavoriteStop(favoriteStop).pipe(
                    map((filteredFavoriteStops) =>
                        JourneyPlannerActions.deleteFavoriteStopSuccess({ favoriteStops: filteredFavoriteStops })
                    ),
                    catchError((err) => {
                        return throwError(err);
                    })
                )
            )
        );
    });
}
